/*
 * @Autor: fengqi
 * @Date: 2019-10-11 10:41:43
 * @LastEditors: fengqi
 * @LastEditTime: 2019-10-12 11:43:39
 */
import axios from 'axios'
// import lockr from 'lockr'
import APIS from '@/api/api'

const API_ROOT = process.env.VUE_APP_BASE_API || ''

// 注入默认配置
axios.defaults = Object.assign(axios.defaults, {
  timeout: 10000
})

// request 请求拦截器
axios.interceptors.request.use(
  config => {
    return config
  },
  err => {
    window.$Toast('请求失败')
    return err
  }
)

// response 响应拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  err => {
    window.$Toast('请求失败')
    return err
  }
)

// 通用请求方法
export default function http (option, data) {
  let isString = typeof option === 'string'

  // 获取 API 配置
  let name = isString ? option : option.api
  let api = APIS[name]

  // 自定义请求头 & 参数
  let params = option.params || {}
  let customHead = option.headers || {}

  // 请求配置对象
  let requestData = {
    method: api.method, // 请求方法
    url: API_ROOT + api.path, // 请求 URL
    params: Object.assign(params, data), // 请求参数
    headers: Object.assign(customHead, {
      // token: lockr.get('token')
    }) // 自定义请求头
  }

  // 发送请求
  return axios.request(requestData).then((res) => {
    if (res.data.state) {
      return res.data
    } else {
      window.$Toast(res.data.message)
      return res.data
    }
  }).catch(res => {
    window.$Toast('请求失败')
    return res
  })
}
